import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './component/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FlexModule } from '@angular/flex-layout';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { environment } from '../environments/environment';
import { SignInComponent } from './component/sign-in/sign-in.component';
import { SignInFormComponent } from './component/sign-in/steps/sign-in-form/sign-in-form.component';
import { SignInSelectProfileComponent } from './component/sign-in/steps/sign-in-select-profile/sign-in-select-profile.component';
import { SignInChangePasswordComponent } from './component/sign-in/steps/sign-in-change-password/sign-in-change-password.component';
import { SignInPasswordRulesComponent } from './component/sign-in/steps/sign-in-password-rules/sign-in-password-rules.component';
import { DevicesComponent } from './component/home/devices/devices.component';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { DateFormatPipe } from './pipe/date-format.pipe';
import { FilterEngineDirective } from './component/filter-engine/filter-engine.directive';
import { DateIntervalFieldComponent } from './component/filter-engine/date-field/date-interval-field.component';
// tslint:disable-next-line:max-line-length
import { DynamicListFieldMultipleSelectsComponent } from './component/filter-engine/dynamic-list-field/multiple-selects/dynamic-list-field-multiple-selects.component';
// tslint:disable-next-line:max-line-length
import { DynamicListFieldSingleSelectComponent } from './component/filter-engine/dynamic-list-field/single-select/dynamic-list-field-single-select.component';
import { InputFieldComponent } from './component/filter-engine/input-field/input-field.component';
import { SelectFieldComponent } from './component/filter-engine/select-field/select-field.component';
import { FilterComponentFactory } from './component/filter-engine/filter-component-factory';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { HeaderInterceptor } from './service/header.interceptor';
import { DeviceDetailPopupComponent } from './component/home/devices/device-detail.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { OverlayContainer } from '@angular/cdk/overlay';
import { DateInputComponent } from './component/date-input/date-input.component';
import { NotificationModule } from './component/notification/notification.module';
import { DialogsModule } from './component/dialogs/dialogs.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UtcDateFormatPipe } from './pipe/utc-date-format.pipe';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DevicesComponent,
    SignInComponent,
    SignInFormComponent,
    SignInSelectProfileComponent,
    SignInChangePasswordComponent,
    SignInPasswordRulesComponent,
    DateFormatPipe,
    UtcDateFormatPipe,
    FilterEngineDirective,
    DateIntervalFieldComponent,
    DynamicListFieldMultipleSelectsComponent,
    DynamicListFieldSingleSelectComponent,
    InputFieldComponent,
    SelectFieldComponent,
    DeviceDetailPopupComponent,
    DateInputComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      useDefaultLang: true,
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatTableModule,
    MatMenuModule,
    MatSortModule,
    MatButtonModule,
    MatPaginatorModule,
    MatToolbarModule,
    FlexModule,
    MatProgressBarModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatListModule,
    MatTooltipModule,
    MatSelectModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatTabsModule,
    MatCheckboxModule,
    FormsModule,
    NotificationModule,
    DialogsModule
  ],
  providers: [
    { provide: 'environment', useValue: environment },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    FilterComponentFactory
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(overlayContainer: OverlayContainer) {
    overlayContainer.getContainerElement().classList.add('default-theme');
  }
}
